import { deleteLocalStorage } from '@/utils/localStorage';

export const clearStorage = (): void => {
	deleteLocalStorage('user_id');
	deleteLocalStorage('user_email');
	deleteLocalStorage('case_id');
	deleteLocalStorage('temporal-password');
};
